import { leagueFetch } from "@leagueplatform/league-fetch";

const DOCUMENTS_API = "/v2/documents";
const PHYSICIAN_FORM_DOCUMENT_TYPE = "PhysicianForm";

export const uploadPhysicianForm = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      data: {
        type: "document",
        attributes: { documentType: PHYSICIAN_FORM_DOCUMENT_TYPE },
      },
    })
  );
  formData.append("files", file);

  const response = await leagueFetch(DOCUMENTS_API, {
    method: "POST",
    body: formData,
  });

  if (!response?.ok) {
    throw new Error(`Physician form upload failed (${response?.status})`);
  }
};
